import { Redux } from '../..'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GygEonFacts, GygEonFactsQueryOptions } from '@/src/types/apps/gygEonFacts'

interface EonFactsInitialState {
  eonFacts: GygEonFacts[]
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: EonFactsInitialState = {
  eonFacts: [],
  loading: false,
  success: null,
  error: null
}

interface EonFactsResponse {
  data: GygEonFacts[]
}

function normalizeEonFactsPayload(raw: unknown): GygEonFacts[] {
  if (raw == null) return []
  const payload = typeof raw === 'object' ? (raw as Record<string, unknown>) : null
  if (!payload) return []

  const data = payload.data
  if (Array.isArray(data)) {
    return data as GygEonFacts[]
  }

  return []
}

export const getEonFactsInTwoDates = createAsyncThunk<EonFactsResponse, GygEonFactsQueryOptions, Redux>(
  'gygEonFacts/getEonFactsInTwoDates',
  async (gygEonFactsQueryOptions, { extra }) => {
    const { restaurantId, startDate, endDate } = gygEonFactsQueryOptions

    const { data: responseData } = await extra.httpClient.get(`restaurants/${restaurantId}/eon-facts`, {
      params: {
        startDate,
        endDate
      }
    })

    return { data: normalizeEonFactsPayload(responseData) }
  }
)

export const update = createAsyncThunk<EonFactsResponse, any, Redux>('gygEonFacts/update', async (data, { extra }) => {
  const { httpClient } = extra

  const { data: responseData } = await httpClient.patch(`restaurants/${data.restaurantId}/eon-facts`, data)

  return responseData
})

const gygEonFactsSlice = createSlice({
  name: 'getAllEonFacts',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getEonFactsInTwoDates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getEonFactsInTwoDates.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.eonFacts = Array.isArray(action.payload?.data) ? action.payload.data : []
      })
      .addCase(getEonFactsInTwoDates.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch eon goals targets'
      })
      .addCase(update.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(update.fulfilled, state => {
        state.loading = false
        state.success = 'Daily count form data updated successfully'
      })
      .addCase(update.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update eon facts'
        state.success = null
      })
  }
})

export default gygEonFactsSlice.reducer
